// load ReactJS front controller
// require('./index.react-coreui.js')
require('./index.antd.js')
